import {FormsySchema, TaxRecordSchemaKeys} from '.';

const getTaxRecordSchema = (getMessage, messages): FormsySchema<TaxRecordSchemaKeys> => ({
    business: {
        identifier: 'business',
        display: {
            text: getMessage(messages, 'ui.profile.tax.business')
        }
    },
    businessName: {
        identifier: 'businessName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'ui.profile.tax.businessName')
        }
    },
    countries: {
        identifier: 'countries',
        display: {
            text: getMessage(messages, 'ui.profile.tax.countries')
        }
    },
    organizationEmail: {
        identifier: 'organizationEmail',
        validations: {
            isEmail: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            isEmail: getMessage(messages, 'errors.com.epicgames.validation.invalid', ['email'])
        },
        display: {
            text: getMessage(messages, 'ui.profile.tax.organizationEmail')
        }
    }
});

export default getTaxRecordSchema;
